import { render } from "./menuControl.vue?vue&type=template&id=5a6070d9&scoped=true"
import script from "./menuControl.vue?vue&type=script&lang=js"
export * from "./menuControl.vue?vue&type=script&lang=js"

import "./menuControl.vue?vue&type=style&index=0&id=5a6070d9&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6070d9"]])

export default __exports__